<template>
  <div>
    <v-card
      text
      class="mx-auto"
      max-width="500"
    >
      <v-card-title>
        <h3 class="title">Review all info before submitting</h3>
        <span class='caption'>*A PDF file of your family history will be avaiable at next page</span><br>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dataModel"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        item-key="name"
        show-expand
        :search="search"
      >
        <template v-slot:expanded-item="{ headers,item }">
          <td :colspan="headers.length">

            <h3 class="headline mb-2">
              {{ item.name }}
            </h3>
            <div class="mb-2">Relationship to patient: {{ item.relationship }}</div>
            <div class="mb-2">Age: {{ item.age }}</div>
            <div class="mb-2">Gender: {{ item.gender }}</div>
            <div class="mb-2">Living: {{ item.isLiving }}</div>

            <div class="mb-2">Notes: {{ item.notes }}</div>

            <v-divider></v-divider>
            <v-layout
              text-xs-left
              wrap
            >
              <v-flex
                mr-3
                mb-2
              >Has the patient ever been diagnosed with cancer?: {{ item.isCancer }}</v-flex>
              <v-flex
                mr-3
                mb-2
              >Has the patient completed any genetic testing previously? {{item.isgeneTest}}</v-flex>
            </v-layout>

          </td>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            small
            @click.stop="editPerson(item)"
          >
            edit
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="personModal"
      width="500"
    >
      <personDetailForm
        :data="dataModel"
        v-on:closePersonModal="personModal = false"
        :indexNum='personIndex'
      />
    </v-dialog>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import personDetailForm from "../PatientFormComp/PersonDetailForm"
export default {
  components: {
    personDetailForm,
  },
  data () {
    return {
      expanded: [],
      singleExpand: false,
      headers: [
        { text: 'Name', align: 'left', value: 'name' },
        { text: 'Relationship', align: 'right', value: 'relationship' },
        { text: 'Age', align: 'right', value: 'age' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      active: [],
      search: null,
      caseSensitive: false,
      personIndex: null,
      personModal: false,
      loading: null,
      panel: [],
      gsflogo: "",
      nameList: [],
      tableSettings: { rowsPerPage: -1 }
    };
  },
  mounted () {
  },

  computed: {
    selected () {
      if (!this.active.length) return undefined
      const id = this.active[0]
      return this.dataModel.find(person => person.name === id)
    },
    filter () {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined
    },
    ...mapFields("patientQuestion", ["dataModel", "formID"])
  },
  methods: {
    getItem () {
      var patient = this.dataModel.find(person => { return person.relationship === "self" })
      var tempItem = [{        name: patient.name + "'s family",
        children: this.dataModel.filter(item => { return item }).map(x => { return { name: x.name } })
      }]
      return tempItem
    },
    editPerson (data) {
         this.personIndex = this.dataModel.findIndex(person => person.pid === data.pid)
      this.personModal = true
    },



    all () {
      this.panel = [...Array(this.dataModel.length).keys()].map(() => true);
    },
    none () {
      this.panel = [];
    },
    relationshipViewFormat (person) {
      if (person.relationship === "self") {
        return "patient";
      }
      if (
        person.relationship === "child" &&
        (person.gender === "Male" || person.gender === "Transgender Male")
      ) {
        return "patient's son";
      } else if (
        person.relationship === "child" &&
        (person.gender === "Female" || person.gender === "Transgender Female")
      ) {
        return "patient's daughter";
      } else if (
        person.relationship === "child" &&
        person.gender === "Gender variant/non-conforming"
      ) {
        return "patient's child";
      }
      if (
        person.relationship === "sibling" &&
        (person.gender === "Male" || person.gender === "Transgender Male")
      ) {
        return "patient's brother";
      } else if (
        person.relationship === "sibling" &&
        (person.gender === "Female" || person.gender === "Transgender Female")
      ) {
        return "patient's sister";
      } else if (
        person.relationship === "sibling" &&
        person.gender === "Gender variant/non-conforming"
      ) {
        return "patient's sibling";
      } else {
        return person.relationship;
      }
    },
    readableTrueFalse (item) {
      if (item === true) {
        return "Yes";
      } else {
        return "No";
      }
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>